import { CIcon } from '~/icons/types'
export const ciBicycleFrameTrapeze: CIcon = {
  width: 24,
  height: 24,
  paths: [
    {
      d:
        'M7.647 14.4h1.01a4.3 4.3 0 0 0-1.72-2.98l-.53.86a3.248 3.248 0 0 1 1.24 2.12Zm-3.3 3.83a3.335 3.335 0 1 1 1.19-6.45l.53-.87a4.265 4.265 0 0 0-1.72-.35 4.335 4.335 0 1 0 4.31 4.84h-1.02a3.328 3.328 0 0 1-3.29 2.83Z',
      class: 'secondary'
    },
    {
      d:
        'm17.237 10.24-.36-1.01-5.32 4.41a1.3 1.3 0 0 0-.82-.29.09.09 0 0 0-.05.01l-1.72-3.94 7.88-.28-.36-.99-7.94.29-.22-.51-1.1-.01.29.67a.865.865 0 0 0-.09.11l-1.36 2.21-.53.87-1.75 2.85a.516.516 0 0 0-.01.51.509.509 0 0 0 .44.26h5.42a1.308 1.308 0 0 0 1.1.6 1.327 1.327 0 0 0 1.33-1.32.388.388 0 0 0-.02-.15Zm-7.79 4.16h-4.34l1.3-2.12.53-.86 1.06-1.74 1.78 4.09a1.321 1.321 0 0 0-.33.63Z',
      class: 'main'
    },
    {
      d:
        'M19.647 10.56a4.603 4.603 0 0 0-1.18.16l-.53-1.48-.28-.8-.64-1.79h1.26a.482.482 0 0 0 .45-.29l.41-.88a.517.517 0 0 0-.25-.67.502.502 0 0 0-.66.25l-.27.59h-1.65a.521.521 0 0 0-.41.21.498.498 0 0 0-.06.46l.65 1.83.36.99.03.09.36 1.01.31.87a4.328 4.328 0 1 0 2.1-.55Zm0 7.67a3.332 3.332 0 0 1-1.76-6.16l1.07 3a.496.496 0 0 0 .47.33.453.453 0 0 0 .16-.03.506.506 0 0 0 .31-.64l-1.09-3.06a3.334 3.334 0 1 1 .84 6.56ZM9.397 7.43a.508.508 0 0 1-.5.5h-.57l-1.1-.01h-.65a.501.501 0 0 1-.5-.5.508.508 0 0 1 .5-.5l2.32.01a.495.495 0 0 1 .5.5Z',
      class: 'secondary'
    }
  ],
  name: 'bicycle-frame-trapeze',
  type: 'solid'
}
